<template>
	<div class="flex w-full flex-col gap-2">
		<div
			v-for="group in groups"
			:key="group.title"
			class="flex flex-col gap-1"
		>
			<p :class="['text-sm font-medium', included ? 'text-won-green' : 'text-won-secondary']">
				{{ group.title }}
			</p>
			<ul class="flex flex-col gap-1">
				<li
					v-for="item in group.items"
					:key="item"
					class="flex items-start gap-1 text-sm text-gray-900"
				>
					<span class="flex h-5 shrink-0 items-center">
						<CheckCircleIcon
							v-if="included"
							class="size-4 text-won-green"
							aria-hidden="true"
						/>
						<MinusIcon
							v-else
							class="size-4 text-gray-900"
							aria-hidden="true"
						/>
					</span>
					<span>{{ item }}</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
import { MinusIcon } from '@heroicons/vue/20/solid';
import { CheckCircleIcon } from '@heroicons/vue/24/outline';

defineProps({
	groups: {
		type: Array,
		required: true,
	},
	// Paid plans tick their features; Basic lists its limits with a dash.
	included: {
		type: Boolean,
		default: false,
	},
});
</script>
